import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function Offer() {
  return <section id="offer" className="py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-100">
      {/* Background Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-101" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-102">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-103">
          <div className="order-2 lg:order-1 flex justify-center lg:justify-end" data-id="element-104">
            <FadeIn direction="right" className="relative w-full max-w-sm" data-id="element-105">
              <div className="absolute inset-0 bg-cyan-500/20 blur-[60px] rounded-full transform scale-90" data-id="element-106" />
              <img src="https://cdn.magicpatterns.com/uploads/k8p8CuRCsVH1AcByAS9i7j/Mockup.png" alt="Operador de la Lattice - Código Silente" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-107" />
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 text-center lg:text-left" data-id="element-108">
            <FadeIn data-id="element-109">
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-110">
                Tu hito de despertar no tiene por qué costar una fortuna.
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-111">
              <p className="text-xl text-gray-300 mb-8 font-light" data-id="element-112">
                El acceso a{' '}
                <span className="font-bold text-white" data-id="element-113">
                  OPERADOR DE LA LATTICE: Código Silente
                </span>{' '}
                tiene un valor de intercambio de solo:
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-114">
              <div className="mb-10 flex flex-col items-center gap-3 p-8 rounded-2xl border border-gold-500/15 bg-gold-500/[0.03]" data-id="element-115">
                <span className="px-4 py-1.5 rounded-full bg-cyan-400/10 border border-cyan-400/30 text-cyan-400 text-xs font-bold tracking-widest uppercase" data-id="element-116">
                  Ahorra 66%
                </span>
                <div className="flex items-baseline gap-3" data-id="element-117">
                  <span className="text-xl text-gray-500 line-through font-light" data-id="element-118">
                    $97
                  </span>
                  <span className="text-6xl sm:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600 drop-shadow-lg leading-none" data-id="element-119">
                    $33
                  </span>
                  <span className="text-xl text-gray-400 font-light" data-id="element-120">USD</span>
                </div>
                <span className="text-sm text-gray-500" data-id="element-121">
                  Acceso inmediato · Pago único
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-122">
              <p className="text-lg text-gray-400 mb-10 italic" data-id="element-123">
                Un precio simbólico para el Operador que está listo para
                recuperar el mando de su partida y dejar de ser fiel a la
                ignorancia.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-124">
              <div className="flex flex-col items-center lg:items-start gap-6" data-id="element-125">
                <CTAButton href="https://www.upwisehub.com/cart/47830011019476:1" data-id="element-126">
                  SÍ — QUIERO ACTIVAR AL OPERADOR
                </CTAButton>
                <p className="text-sm text-cyan-400 font-medium tracking-wide uppercase" data-id="element-127">
                  Tu energía vital vuelve a ti en el momento en que decides
                  jugar.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}